import Cookies from "js-cookie";

const exitBtn = document.querySelector(".exit-button");

// init exitBtn in cookies
if (!Cookies.get("exitBtn")) {
  Cookies.set("exitBtn", "");
} else {
  if (Cookies.get("exitBtn") === "hide") {
    exitBtn && exitBtn.classList.add("hidden");
  }
}

if (exitBtn) {
  exitBtn.addEventListener("click", () => {
    exitSite();
  });

  // Leave site on Shift + Shift + Shift in 10 seconds
  // let shiftPressed = 0;
  // let shiftTimer: number;
  // document.addEventListener("keydown", (event) => {
  //   if (event.key === "Shift") {
  //     shiftPressed++;
  //     if (shiftPressed === 1) {
  //       shiftTimer = window.setTimeout(() => {
  //         shiftPressed = 0;
  //       }, 10000);
  //     } else if (shiftPressed === 3) {
  //       clearTimeout(shiftTimer);
  //       exitSite();
  //     }
  //   } else {
  //     shiftPressed = 0;
  //   }
  // });

  const closeExitBtn = exitBtn.querySelector("button");

  if (closeExitBtn) {
    closeExitBtn.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();
      exitBtn.classList.add("hidden");

      Cookies.set("exitBtn", "hide", {
        expires: 1 / 24,
      });
    });
  }
}

function exitSite() {
  history.replaceState(null, "", "/");
  document.documentElement.style.backgroundColor = "white";
  document.documentElement.style.overflow = "hidden";
  document.documentElement.style.pointerEvents = "none";
  document.documentElement.style.opacity = "0";
  window.location.replace("https://www.google.com/");
}
